import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    LOGOUT_SUCCESS,
    GET_LOGIN_INFO_SUCCESS,
    GET_USER_DATA_REQUEST,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    UPDATE_USER_DATA_SUCCESS,
    SWITCH_IMPL_SUCCESS,
    OPEN_2FA,
    CLOSE_2FA,
    LOGIN_2FA_SUCCESS,
    LOGIN_INFO_REQUEST,
    LOGIN_OAUTH_REQUEST,
    LOGIN_OAUTH_SUCCESS,
    RESET_USER_LOGIN_INFO,
    SET_SCOPED_TOKEN,
} from 'constants/ActionTypes';

const initialState = {
    request: false,
    oauthRequest: false,
    authenticated: false,
    error: null,
    user: {},
    impl: null,
    is2FAOpen: false,
    data2FA: {},
    userLoginInfo: {},
    scopedToken: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case LOGIN_INFO_REQUEST:
            return {
                ...state,
                authenticated: false,
                error: null,
            };
        case GET_LOGIN_INFO_SUCCESS:
            return {
                ...state,
                authenticated: false,
                error: null,
                userLoginInfo: action.payload,
            };
        case LOGIN_REQUEST:
            return {
                ...state,
                request: true,
                authenticated: false,
                error: null,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                request: false,
                authenticated: true,
                error: null,
                impl: null,
            };
        case LOGIN_ERROR:
            return {
                ...state,
                request: false,
                oauthRequest: false,
                authenticated: false,
                error: action.payload,
                is2FAOpen: false,
                impl: null,
            };
        case LOGIN_OAUTH_REQUEST:
            return {
                ...state,
                oauthRequest: true,
                authenticated: false,
                error: null,
            };
        case LOGIN_OAUTH_SUCCESS:
            return {
                ...state,
                oauthRequest: false,
                authenticated: true,
                error: null,
                impl: null,
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                request: false,
                oauthRequest: false,
                authenticated: false,
                error: null,
                impl: null,
            };
        case RESET_USER_LOGIN_INFO:
            return {
                ...state,
                userLoginInfo: {},
            };
        case GET_USER_DATA_REQUEST:
        case GET_USER_DATA_ERROR:
            return {
                ...state,
            };
        case GET_USER_DATA_SUCCESS: {
            const user = action.payload;
            const { impl, canSwitchImpl } = user;
            return {
                ...state,
                user,
                impl: canSwitchImpl ? null : impl,
                canSwitchImpl,
            };
        }
        case UPDATE_USER_DATA_SUCCESS:
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            };
        case SWITCH_IMPL_SUCCESS:
            return {
                ...state,
                impl: action.payload,
            };
        case OPEN_2FA:
            return {
                ...state,
                is2FAOpen: true,
                data2FA: action.payload,
            };
        case CLOSE_2FA:
            return {
                ...state,
                is2FAOpen: false,
                request: false,
            };
        case LOGIN_2FA_SUCCESS:
            return {
                ...state,
                request: false,
                authenticated: true,
                error: null,
                impl: null,
                is2FAOpen: false,
            };
        case SET_SCOPED_TOKEN:
            return {
                ...state,
                scopedToken: action.payload.scopedToken,
            };
        default:
            return {
                ...state,
            };
    }
}
